<kendo-grid [data]="gridView" [selectable]="true" style="height: auto">
    <kendo-grid-column title="Module" [width]="400">
        <ng-template kendoGridCellTemplate let-record>
            <i class="fas" [ngClass]="record.page.icon"></i>
            &nbsp;
            <span>{{ record.page.name }}</span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="page.hasPage" title="Grant Access">
        <ng-template kendoGridCellTemplate let-record>
            <input
                #headers
                type="checkbox"
                [checked]="record.page.hasPage"
                (click)="clickGrantAccess(record.page, record.pages)"
            />
        </ng-template>
        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="let-columnIndex">
            {{ column.title }}
            <input #checker type="checkbox" (click)="checkAll()" [checked]="checkFlag" />
        </ng-template>
    </kendo-grid-column>
    <div *kendoGridDetailTemplate="let dataItem2">
        <kendo-grid [data]="dataItem2.pages" [selectable]="true" style="height: auto">
            <kendo-grid-column field="name" title="Page" [width]="400"></kendo-grid-column>

            <kendo-grid-column field="page.hasPage" title="Grant Access">
                <ng-template kendoGridCellTemplate let-record2>
                    <input
                        type="checkbox"
                        [checked]="record2.hasPage"
                        class="subModule"
                        (click)="clickGrantAccess(record2)"
                    />
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="routerURL" title="Page URL">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.routerURL }}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</kendo-grid>
